/// <reference path="../svg.d.ts" />
import React from 'react';
import {
  MapPin as LucideMapPin,
  MapPinPlus as LucideMapPinPlus,
  Navigation as LucideNavigation,
  Map as LucideMap,
  Locate as LucideLocate,
  LocateFixed as LucideLocateFixed,
  Route as LucideRoute,
  MapPinned as LucideMapPinned,
} from 'lucide-react';
import { getIconProps, IconProps } from '../utils';
import LocationWithCheckMarkSvg from '../assets/order/location-with-check.svg?react';

export const LocationIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideMapPin {...iconProps} />;
};

/** this icon is used to add a location. */
export const LocationAddIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideMapPinPlus {...iconProps} />;
};

/** this icon is used to get the current location. */
export const CurrentLocationIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideNavigation {...iconProps} />;
};

export const MapIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideMap {...iconProps} />;
};

export const LocateIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideLocate {...iconProps} />;
};

export const LocateFixedIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideLocateFixed {...iconProps} />;
};

export const RouteIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideRoute {...iconProps} />;
};

export const MapPinnedIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideMapPinned {...iconProps} />;
};

export const LocationWithCheckMarkIcon: React.FC<IconProps> = props => {
  return <LocationWithCheckMarkSvg {...getIconProps(props)} />;
};
